import { render } from "./TemplateMTK.vue?vue&type=template&id=3db76b1b"
import script from "./TemplateMTK.vue?vue&type=script&lang=js"
export * from "./TemplateMTK.vue?vue&type=script&lang=js"
script.render = render

export default script